import React, { useState, useEffect, useRef } from 'react';
import './PhoneInput.css';
import validate from '../../common/validate';
import logComponent from '../../common/logComponent';

export default function PhoneInput({ initialValue, label, instructions, name, showError, errorMessage, rules, onValidate }) {
  const [value, setValue] = useState(initialValue ? initialValue : '');
  const [validationDetails, setValidationDetails] = useState(null);
  const [isValid, setIsValid] = useState(null);

  if (logComponent('PhoneInput')) { console.debug('PhoneInput rendered'); }

  useEffect(() => {
    if (logComponent('PhoneInput')) { console.debug('PhoneInput onMount'); }
    validateThis();
  }, [])


  const valueRef = useRef((initialValue ? initialValue : ''));


  const setValueRef = (el) => {
    if (logComponent('PhoneInput')) { console.debug('PhoneInput setValueRef'); }
    valueRef.current = el;
    setValue(el);
  }

  const updateValue = (e) => {
    if (logComponent('PhoneInput')) { console.debug('PhoneInput updateValue'); }
    setValueRef(e.target.value);
  }

  const validateThis = () => {
    if (logComponent('PhoneInput')) { console.debug('PhoneInput validateThis'); }

    // strip any non-numerical characters from value before validating
    let cleanValue = valueRef.current.replace(/[^\d]/g, '');
    
    let validationDetailsThis = [];
    for (let rule in rules) {
      validationDetailsThis.push({
        rule: rule,
        valid: validate[rule](cleanValue, rules[rule])
      })
    }

    let isValidThis = validationDetailsThis.reduce((prev, curr) => prev && curr.valid, true);

    setValidationDetails(validationDetailsThis);
    setIsValid(isValidThis);
    

    onValidate({
      name: name,
      isValid: isValidThis,
      value: cleanValue
    });
  }  

    return (
      <div className="Phone-Input-Group">
      {
          showError && !isValid &&
        <p className="Phone-Input-Group__error">{ errorMessage }</p>
      }         
        <label 
          className="Phone-Input-Group__label"
          htmlFor={name + '-input'}>
                {label}{
          rules && rules.required &&
          <span className="Phone-Input-Group__required"> *</span>
}
        </label>
        <input 
          id={name + '-input'}
          className="Phone-Input-Group__input" 
          type="tel"
          spellCheck="false"
          value={value}
          onChange={updateValue}
          onBlur={validateThis}
          />
        { 
          instructions &&
          <span className="Phone-Input-Group__instructions">{ instructions }</span>
        }
      </div>
    );
}